<template>
  <v-container>
    <v-row>
      <v-col>
        <div style="float:left">
          <v-btn link v-on:click="goBack">
            <v-icon primary small>
              mdi-chevron-left
            </v-icon>
            BACK
          </v-btn>
        </div>
        <div class="raceNumber" style="margin-left:10px">{{ race.totalRaceNumber }}
        Round: {{ $route.params.round }} Race: {{
            $route.params.race
          }}</div>
      </v-col>
    </v-row>
    <v-row v-for="(entry) in resultEntries.results" v-bind:key="entry.place" class="divider">
      <v-col class="condensed">
        <div class="placeContainer">{{ entry.place }}</div>
        <a v-for="(boat) in entry.boats" class="boatContainer" v-bind:key="boat.number"
           v-bind:class="{selectedBoatContainer:boat.selected,finished:finished(boat),notSelectedBoatContainer:entryComplete(entry)}"
           v-bind:style="{ 'background-color': '#'+boat.rgb}" v-on:click="toggleBoat(entry,boat)">
          <div class="numberContainer" v-bind:class="{selectedBoat:boat.selected}">{{
              boat.number
            }}
          </div>
        </a>
        <div style="padding:5px;margin-left:5px;float:left">
          <v-icon small :color="entryComplete(entry)?'green darken-2':'amber darken-2'">
            {{ entryComplete(entry) ? 'mdi-check' : 'mdi-help' }}
          </v-icon>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>

        <div style="float:left">
          <div class="entryLabel">P</div>
          <div class="boatGroupIndicator" v-bind:title="race.team1Boat.reference"
               v-bind:style="{ 'background-color': '#'+race.team1Boat.rgb}"></div>
          <div style="float:left"><div class="teamNumber">{{ race.team1.teamId }}</div>
            <div style="float:left">- {{ race.team1.name }}({{race.team1.initialSeed}})</div>
          </div>
          <div class="entryLabel" style="clear:both">S</div>
          <div class="boatGroupIndicator" v-bind:title="race.team2Boat.reference"
               v-bind:style="{ 'background-color': '#'+race.team2Boat.rgb}">
          </div>
          <div style="float:left"><div class="teamNumber">{{ race.team2.teamId }}</div>
            <div style="float:left">- {{ race.team2.name }}({{race.team2.initialSeed}})</div>
          </div>
        </div>
        <div style="float:left;margin-left:5px">
          <div v-if="race.winner" style="float:left">&nbsp;{{ resultEntries.preliminary[race.team1.teamId] }}
            <template v-if="race.winner===race.team1.teamId">&nbsp;<span class="winners">WIN</span></template>
          </div>
          <div v-if="race.winner" style="clear:both">&nbsp;{{ resultEntries.preliminary[race.team2.teamId] }}
            <template v-if="race.winner===race.team2.teamId">&nbsp;<span class="winners">WIN</span></template>
          </div>
        </div>

      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div align="right">
          <v-btn class="primary" v-on:click="confirmResults">SUBMIT RESULTS</v-btn>
        </div>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="showDialog" persistent max-width="320">
        <v-card>
          <v-card-title class="headline">
            Are you sure you're
            ready to submit these
            results?
          </v-card-title>
          <v-card-text>This cannot be undone! <br><br>
            <v-alert border="top"
                     :color="resultEntries.finishedBoats.length===resultEntries.results.length ? 'green': 'red'" dark>
              <b>{{ resultEntries.finishedBoats.length }}/{{ resultEntries.results.length }}</b> finishes recorded
              <br>Winner: <b>{{ race.winner }}</b>
            </v-alert>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="showDialog = false">Cancel</v-btn>
            <v-btn text @click="submitResults();showDialog = false">Submit</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

  </v-container>
</template>

<script>
import {utils} from "@/utils/utils";
import {rounds} from "@/utils/rounds";
import {teams} from "@/utils/teams";

export default {


  data: () => ({
    resultEntries: {},
    race: {},
    round: {},
    showDialog: false,
    roundNUmber: undefined,
    raceNumber: undefined,
  }),
  created() {
    this.buildResults();
  },
  methods: {

    goTo: function (path) {
      this.$router.push({path: path}).catch(() => {
      });
    },
    goBack: function(){
      if(!this.race.result){
        delete this.race.winner;
        delete this.race.loser;
      }
      this.goTo('/results');
    },

    confirmResults: function () {
      this.showDialog = true;
    },
    submitResults: function () {
      this.race.result = this.resultEntries.preliminary;
      rounds.setRoundsFirestore(this.$store, this.round);

      if(this.round.number===1){
        // we calculate round 2 on the fly (special case)  (don't do this for round robins)
        if(!this.$store.state.event.roundRobin){
          rounds.getMatchUps(this.$store, this.round.className)
        }
      }
      if (this.roundComplete()) {
        teams.updateStandings(this.$store, this.round)
        console.log("Last round saved -> standings updated!")
        if(this.$store.state.event.roundRobin){
          rounds.getRoundRobin(this.$store, this.round.className)
        } else {
          rounds.getMatchUps(this.$store, this.round.className)
        }
        console.log("Last round saved -> new round added")
      }
      this.goTo('/results');
    },

    roundComplete: function () {
      let resultsCount = 0;
      this.round.races.forEach((race) => {
        if (race.result) {
          resultsCount++;
        }
      });
      return resultsCount === this.$store.state.teams.length/2;
    },

    toggleBoat: function (entry, boat) {
      this.race.winner = "";
      this.race.loser = "";
      const index = this.resultEntries.finishedBoats.indexOf(boat.number)
      if (!boat.selected && index > -1) {
        //its already toggled on somewhere else
        return false;
      }
      const initialState = boat.selected === true;
      entry.boats.forEach((boatLoop) => {
        boatLoop.selected = false;
      })
      boat.selected = !initialState;
      // rebuild finished boats
      this.resultEntries.finishedBoats = [];
      this.resultEntries.preliminary = {};
      let place = 0;
      this.resultEntries.preliminary[this.resultEntries.results[0].boats[0].teamId] = [];
      this.resultEntries.preliminary[this.resultEntries.results[0].boats[this.resultEntries.results[0].boats.length - 1].teamId] = [];
      const teams = [];
      this.resultEntries.results.forEach((entryLoop) => {
        place++;
        entryLoop.boats.forEach((boatLoop) => {
          if (teams.indexOf(boatLoop.teamId) < 0) {
            teams.push(boatLoop.teamId);
          }
          if (boatLoop.selected) {
            this.resultEntries.finishedBoats.push(boatLoop.number);
            this.resultEntries.preliminary[boatLoop.teamId].push(place);
          }
        })
      });
      this.getWinner(teams);
      this.$forceUpdate()
    },
    getWinner: function (teams) {
      this.resultEntries.score = {};
      for (const [teamId, teamResults] of Object.entries(this.resultEntries.preliminary)) {
        // dnf, dns, dsq, ret = fleet size +1 (7) points
        let teamTotal = 7 * (3 - teamResults.length);
        teamResults.forEach((place) => teamTotal += place);
        this.resultEntries.score[teamId] = teamTotal;
      }
      // deal with equal scores
      if (this.resultEntries.score[teams[0]] === this.resultEntries.score[teams[1]]) {
        if (this.resultEntries.preliminary[teams[0]].indexOf(1) > -1) {
          this.race.winner = teams[0];
          this.race.loser = teams[1];
        } else if (this.resultEntries.preliminary[teams[1]].indexOf(1) > -1) {
          this.race.winner = teams[1];
          this.race.loser = teams[0];
        }
      } else {
        this.race.winner = this.resultEntries.score[teams[0]] < this.resultEntries.score[teams[1]] ? teams[0] : teams[1];
        this.race.loser = this.resultEntries.score[teams[0]] > this.resultEntries.score[teams[1]] ? teams[0] : teams[1];
      }
    },
    buildResults: function () {
      this.resultEntries.preliminary = {};
      this.roundNumber = parseInt(this.$route.params.round);
      this.raceNumber = parseInt(this.$route.params.race);
      this.round = this.$store.state.rounds.find((round) => round.number === this.roundNumber)
      this.race = this.round.races.find((race) => race.raceCount === this.raceNumber);
      if (!this.race.team1Boat.sailNumbers) {
        return false;
      }
      if(this.race.result){
        this.resultEntries.preliminary=this.race.result;
      }
      this.resultEntries.results = [];
      this.resultEntries.finishedBoats = [];
      for (let i = 0; i < this.race.team1Boat.sailNumbers.length * 2; i++) {
        const entry = {};
        entry.place = utils.ordinalSuffixOf(i + 1);
        entry.boats = [];
        this.race.team1Boat.sailNumbers.forEach((boat) => {
          entry.boats.push({
            rgb: this.race.team1Boat.rgb,
            number: boat,
            ref: this.race.team1Boat.reference,
            teamId: this.race.team1.teamId,
            teamName: this.race.team1.name,
          });
        });
        this.race.team2Boat.sailNumbers.forEach((boat) => {
          entry.boats.push({
            rgb: this.race.team2Boat.rgb,
            number: boat,
            ref: this.race.team2Boat.reference,
            teamName: this.race.team2.name,
            teamId: this.race.team2.teamId
          });
        });
        this.resultEntries.results.push(entry);
      }
    },
    finished: function (boat) {
      return this.resultEntries.finishedBoats.indexOf(boat.number) > -1;
    },
    entryComplete: function (entry) {
      const found = entry.boats.find((boat) => boat.selected === true)
      return found !== undefined && found !== false;
    }
  },
  computed: {}
}
</script>

<style>
.boatGroupIndicator {
  width: 20px;
  height: 20px;
  border-radius: 2px;
  border: 1px solid #666;
  margin-right: 3px;
  float: left;
}

.divider {
  border-bottom: 1px solid #cccccc;
}

.boatContainer {
  padding: 8px 4px 8px 4px;
  margin: 1px;
  float: left;
  background-color: rgba(255, 255, 255, .6);
  border-radius: 5px;
  min-width: 50px;
  align-content: center;
  text-align: center;
}

.finished {
  opacity: 0;
}

.light-divider {
  border-bottom: 1px solid #eeeeee;
}

.placeContainer {
  float: left;
  width: 30px;
  margin: 10px 10px;
}

.ctr-radio-group {
  margin: 0;
  padding: 0;
}

.condensed {
  margin: 0;
  padding: 1px 0 1px 0;
}

.resultsHeading {
  font-size: large;
  margin: 15px;
}

.selectedBoat {
  background-color: #fff !important;
}

.selectedBoatContainer {
  opacity: 1 !important;
}

.notSelectedBoatContainer {
  opacity: 0.2;
}

.winners {
  background-color: goldenrod;
  color: white;
  padding: 1px 5px;
  border-radius: 10px;
  font-size: small;
  margin-left: 5px;
}

.numberContainer {
  margin: 3px;
  background-color: rgba(255, 255, 255, .8);
  border-radius: 5px;
}
</style>